/* 会員登録フォーム（Shopify Forms）に形式バリデーションを追加する。必須チェックはアプリ側に任せる */
(function () {
  if (window.__customRegisterValidation) return;
  window.__customRegisterValidation = true;

  var container = document.querySelector('.custom-register__form');
  if (!container) return;

  // フィールド id ごとの形式ルール（問い合わせフォームの pattern / title と同一）
  var RULES = {
    'custom#phone': {
      re: /^0\d{9,10}$/,
      msg: '電話番号を0から始まる10〜11桁の数字で入力してください（例: 0312345678）',
      normalize: function (v) {
        return v
          .replace(/[０-９]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); })
          .replace(/[\s\-‐‑–—―−－ー]/g, '');
      }
    },
    'custom#postal': {
      re: /^\d{3}-?\d{4}$/,
      msg: '7桁の郵便番号 (例: 100-0001) を入力してください'
    }
  };

  // 既存の [class*="formError"] 用スタイルに乗せるためのクラス名
  var MSG_CLASS = 'custom-formError';

  // container 配下の light DOM と全 shadowRoot を集める
  function roots() {
    var list = [container];
    (function walk(node) {
      node.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) { list.push(el.shadowRoot); walk(el.shadowRoot); }
      });
    })(container);
    return list;
  }

  // ルール対象のフィールドを列挙する（再レンダーで差し替わるため都度探索する）
  function eachField(fn) {
    roots().forEach(function (r) {
      if (!r.getElementById) return;
      Object.keys(RULES).forEach(function (id) {
        var el = r.getElementById(id);
        if (el) fn(el, RULES[id]);
      });
    });
  }

  function containerOf(field) {
    return field.closest('[class*="formFieldContainer"]') || field.parentElement;
  }

  function errorElOf(field) {
    var cont = containerOf(field);
    var n = cont && cont.nextElementSibling;
    return (n && n.classList && n.classList.contains(MSG_CLASS)) ? n : null;
  }

  function clearError(field) {
    field.removeAttribute('aria-invalid');
    var el = errorElOf(field);
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  // アプリ標準と同じ「container の直後」へ挿し、既存の再配置・余白調整をそのまま活かす
  function showError(field, msg) {
    field.setAttribute('aria-invalid', 'true');
    var el = errorElOf(field);
    if (!el) {
      var cont = containerOf(field);
      if (!cont || !cont.parentElement) return;
      el = document.createElement('p');
      el.className = MSG_CLASS;
      cont.parentElement.insertBefore(el, cont.nextSibling);
    }
    el.textContent = msg;
  }

  // 値を書き換え、アプリ側の状態にも反映させる
  function normalizeField(field, rule) {
    if (!rule.normalize) return;
    var v = field.value || '';
    var n = rule.normalize(v);
    if (n === v) return;
    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(field, n);
    field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }

  // 空欄は必須チェック（アプリ側）に任せ、入力済みの形式だけを見る
  function check(field, rule) {
    normalizeField(field, rule);
    var v = (field.value || '').trim();
    if (!v || rule.re.test(v)) { clearError(field); return true; }
    showError(field, rule.msg);
    return false;
  }

  function validateAll() {
    var first = null;
    eachField(function (field, rule) { if (!check(field, rule) && !first) first = field; });
    if (first) { try { first.focus(); } catch (e) {} }
    return !first;
  }

  function targetOf(e) {
    return e.composedPath ? e.composedPath()[0] : e.target;
  }

  // 送信ボタンの click を capture 段階で先回りし、形式エラーならアプリのハンドラごと止める
  window.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    if (path.indexOf(container) === -1) return;
    var isSubmit = path.some(function (n) {
      return n.nodeType === 1 && n.matches && n.matches('button[type="submit"], [class*="formSubmitButton"]');
    });
    if (!isSubmit || validateAll()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  // 入力中は解除のみ（打鍵ごとにエラーを出さない）
  container.addEventListener('input', function (e) {
    var t = targetOf(e);
    eachField(function (field, rule) {
      if (field !== t) return;
      var v = (field.value || '').trim();
      if (rule.normalize) v = rule.normalize(v);
      if (!v || rule.re.test(v)) clearError(field);
    });
  }, true);

  // フォーカスが外れた時点で検証する（focusout は container まで届かないため shadowRoot に capture でバインド）
  function bindFields() {
    eachField(function (field, rule) {
      if (field.__customBlurBound) return;
      field.__customBlurBound = true;
      field.getRootNode().addEventListener('blur', function (e) {
        if (e.target === field) check(field, rule);
      }, true);
    });
  }

  bindFields();
  ['pointerdown', 'keydown', 'focusin'].forEach(function (type) {
    window.addEventListener(type, bindFields, true);
  });
})();
